import React, { FC, ReactNode } from 'react';
import { Modal as BaseModal, ModalProps as BaseModalProps } from 'antd';
import cx from 'classnames';

import { useLang } from 'hooks';
import { Cross } from 'components/icons';
import { Override } from 'types/common';

import Paragraph from '../Paragraph';
import Title from '../Title';

import styles from './styles.module.css';

const widths = {
  small: 320,
  middle: 450,
  large: 640,
};

type ModalProps = Override<BaseModalProps, {
  caption?: ReactNode;
  width?: keyof typeof widths;
}>;

const Modal: FC<ModalProps> = ({
  className,
  title,
  caption,
  cancelText,
  width = 'middle',
  closeIcon = <Cross />,
  okButtonProps,
  cancelButtonProps,
  destroyOnClose = true,
  ...props
}) => {
  const lang = useLang();

  return (
    <BaseModal
      className={cx(styles.root, className)}
      title={title && (
        <>
          <Title className={styles.title} level={3}>{title}</Title>
          <Paragraph className={styles.caption} type="secondary">{caption}</Paragraph>
        </>
      )}
      cancelText={cancelText ?? lang.get('common.actions.cancel')}
      width={widths[width]}
      closeIcon={closeIcon}
      okButtonProps={{
        ...okButtonProps,
        className: cx(styles.submit, okButtonProps?.className),
        size: 'large',
      }}
      cancelButtonProps={{
        ...cancelButtonProps,
        className: cx(styles.cancel, cancelButtonProps?.className),
        size: 'large',
      }}
      destroyOnClose={destroyOnClose}
      {...props}
    />
  );
};

export default Modal;
